<template>
    <div id="fanroomview">
        <div v-if="mediaOpen && started" >
            <Navigator id="topbar" :unclickable="true"></Navigator>
        </div>
        <div v-else>
            <Navigator id="topbar"></Navigator>
        </div>
        <div v-if="!started" class="fullwin container text-center">
            <div style="height: 100%">
                <div class="card mt-5">
                    <div class="card-body text-dark">
                        <h4>You are about to join a Kalameeting</h4>
                        <p>
                            <Video id="preview" :muted="true" :stream="localStream"
                                   :vid-height="370" :vid-width="400" :callback="resize">
                            </Video>
                        </p>
                        <div v-if="!mediaOpen">
                            <p>Make sure your camera and microphone are working.</p>
                            <b-button pill @click="openMedia">
                                Enable Camera And Microphone
                            </b-button>
                        </div>
                        <div v-if="mediaOpen">
                            <p>All set! You can join now! </p>
                            <b-button pill @click="joinSession">Join Call</b-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="mediaOpen && started" class="fullwin container-fluid text-center">
            <div id="timer" v-if="timer">
                <p :class="timercolor"><i class="material-icons">alarm_on</i>
                    <span id="timercount">{{timer}}</span></p>
            </div>
            <div class="row h-100 align-items-center" id="videorow">
                <div id="selfiemode" class="row h-100 align-items-center text-center"
                     v-if="selfiemode">
                    <div id="photowrap" class="output" style="display:none">
                        <img id="photo" alt="The screen capture will appear in this box.">
                    </div>
                    <div id="selfiewrap" v-if="!selfieDone" >
                        <Video id="remoteVideoSelfie" :muted="false" :stream="remoteStream"
                               :vid-height="vidHeight" :vid-width="vidWidth" :callback="resize"/>
                        <Video id="localVideoSelfie" :muted="true" :stream="localStream"
                               :vid-height="vidHeight" :vid-width="vidWidth" :callback="resize"/>
                    </div>
                </div>
                <div id="vid1" v-if="!selfiemode" class="vidwrap">
                    <Video id="localVideo" :muted="true" :stream="localStream"
                           :vid-height="vidHeight" :vid-width="vidWidth" :callback="resize"/>
                </div>
                <div id="vid2" v-if="!selfiemode" class="vidwrap">
                    <Video id="remoteVideo" :muted="false" :stream="remoteStream"
                           :vid-height="vidHeight" :vid-width="vidWidth"/>
                    <!--      <div v-if="mediaOpen && started" style="position:absolute;
                    margin-top:-20px">-->
                    <!--      <b-button pill @click="hangUp">Hang Up</b-button>-->
                    <!--                    </div>-->
                </div>
            </div>
            <div id="controlbar" v-if="!selfiemode">
                <b-button id="endcall" class="ctr-btn" variant="danger" @click="hangUp">
                    <i class="material-icons">call_end</i>
                </b-button>
                <b-popover variant="dark" target="endcall" triggers="hover" placement="top">
                    <template v-slot:title>End your call</template>
                    You can exit the call at any time.
                </b-popover>
            </div>
        </div>
        <div id="lowbar">
        </div>
    </div>
</template>

<style>
    #selfiemode {
        background: #1abc9c;
        margin:0;
        right: 0;
        position: relative;
        height: 100%;
        width: 100%;
        top: 0;
        z-index: 2;
    }
    #selfiemode #selfiewrap, #selfiemode #photowrap {
        border: 3px #ffc000 groove;
        object-fit: cover;
        overflow: hidden;
        border-radius: 20px;
        position: relative;
        top:0;
        left:0;
        margin: auto;
        vertical-align: middle;
        align-content: center;
        align-items: center;
    }

    #selfiemode Video {
        border: 0;
        border-radius: 0px;
    }
    #fanroomview {
        width: 100%;
        height: 100%;
        position: fixed;
        background: #06424d;
        color: white;
    }

    #timer {
        position: absolute;
        z-index: 1999001;
        width: 100%;

    }

    #timer p {
        font-size: 20px;
        width: 150px;
        border-radius: 20px;
        margin: auto;
        margin-top: -55px;
        padding: 4px;
        color: #06424d;
    }
    #timer span {
        display: inline;
        vertical-align: middle;
    }
    #timer i {
        display: inline;
        vertical-align: middle;
        font-size: 30px;
    }
    #lowbar {
        min-height: 5rem;
        height:5%;
    }

    Video {
        border: 3px #ffc000 groove;
        object-fit: cover;
        overflow: hidden;
        border-radius: 20px;
    }

    #controlbar {
        position: relative;
        width: 100%;
        top:-25px;
    }

    #controlbar .ctr-btn {
        margin: 20px 5px;
        color: white;
        width: 60px;
        height: 60px;
        border-radius: 60px;
        border-width: 0;
    }
    #controlbar i {
        font-size: 30px;
        display: inline;
        vertical-align: middle;
    }
    #requestSelfie{
        margin-top: 0;
        border-radius: 60px;
        width: 60px;
        height: 60px;
    }
</style>
<script>
import firebase from '../../firebase';
import Video from '../../components/kalameeting/Video.vue';
import Navigator from '../../components/Navigator.vue';

const configuration = {
    iceServers: [{
        urls: ['stun:stun1.l.google.com:19302', 'stun:stun2.l.google.com:19302']
    }],
    iceCandidatePoolSize: 10
};


const vm = {
    data() {
        return {
            roomId: '',
            mediaOpen: false,
            started: false,
            peerConnection: null,
            channel: null,
            localStream: null,
            remoteStream: null,
            vidHeight: 0,
            vidWidth: 0,
            timer: null,
            timerActive: null,
            timercolor: 'bg-primary',
            selfiemode: false,
            selfieDone: false,
            picture: null,
            meetingId: null
        };
    },
    components: {
        Navigator,
        Video
    },
    watch: {
        timer() {
            const min = this.timer.split(':')[0];
            const sec = this.timer.split(':')[1];
            if (min < 1 && sec < 11) {
                this.timercolor = 'bg-danger';
            } else if (min < 1 && sec < 31) {
                this.timercolor = 'bg-warning';
            }
        },
        picture(exists) {
            if (exists) {
                const photowrap = document.getElementById('photowrap');
                photowrap.style.display = 'block';
                this.photo = document.getElementById('photo');
                firebase.meetingImages.child(this.meetingId)
                    .getDownloadURL()
                    .then((url) => {
                        this.photo.setAttribute('src', url);
                        this.selfieDone = true;
                    });
            } else if (this.selfiemode) {
                const photowrap = document.getElementById('photowrap');
                photowrap.style.display = 'none';
                this.photo = null;
                this.selfieDone = false;
            }
        }
    },
    methods: {
        openMedia() {
            const preview = document.getElementById('preview');
            navigator.mediaDevices.getUserMedia({
                audio: true,
                video: {
                    width: { ideal: 1280 },
                    height: { ideal: 720 }
                }
            })
                .then((stream) => {
                    this.localStream = stream;
                    this.mediaOpen = true;
                    this.remoteStream = new MediaStream();
                    preview.srcObject = this.localStream;
                })
                .catch((err) => {
                    console.log('Failed to obtain User Media', err);
                    alert('Your browser is not supported. Please try using another device');
                });
        },
        async joinSession() {
            console.log('Joining Call');
            const roomRef = firebase.roomsCollection.doc(this.roomId);
            const roomSnapshot = await roomRef.get();
            if (roomSnapshot.exists) {
                this.peerConnection = new RTCPeerConnection(configuration);
                this.startPeerConnectionListeners();
            }
            this.localStream.getTracks().forEach((track) => {
                this.peerConnection.addTrack(track, this.localStream);
            });

            const callees = roomRef.collection('callees');
            this.peerConnection.addEventListener('icecandidate', (event) => {
                if (!event.candidate) {
                    console.log('Got final candidate!');
                    return;
                }
                callees.add(event.candidate.toJSON());
            });

            this.peerConnection.addEventListener('track', (event) => {
                console.log('Got Remote track:', event.streams[0]);
                event.streams[0].getTracks().forEach((track) => {
                    console.log('Add a track to remoteStream ', track);
                    this.remoteStream.addTrack(track);
                });
            });

            const offer = roomSnapshot.data().offer;
            console.log('Got Offer:', offer);
            await this.peerConnection.setRemoteDescription(new RTCSessionDescription(offer));
            const answer = await this.peerConnection.createAnswer();
            console.log('Created answer:', answer);

            await this.peerConnection.setLocalDescription(answer);

            const roomWithAnswer = {
                answer: {
                    type: answer.type,
                    sdp: answer.sdp
                },
                guest: this.$store.state.currentUser.uid
            };
            await roomRef.update(roomWithAnswer);

            this.addCaller();

            this.started = true;
            this.resize();
        },
        addCaller() {
            firebase.roomsCollection.doc(this.roomId)
                .collection('callers')
                .onSnapshot((snapshot) => {
                    snapshot.docChanges().forEach(async (change) => {
                        if (change.type === 'added') {
                            const data = change.doc.data();
                            console.log('Got new remote ICE Candidate');
                            await this.peerConnection.addIceCandidate(new RTCIceCandidate(data));
                        }
                    });
                });
        },
        startPeerConnectionListeners() {
            this.peerConnection.addEventListener('connectionstatechange', () => {
                console.log(`Connection state change: ${this.peerConnection.connectionState}`);
            });
            this.peerConnection.addEventListener('signalingstatechange', () => {
                console.log(`Signaling state change: ${this.peerConnection.signalingState}`);
            });
            this.peerConnection.addEventListener('iceconnectionstatechange', () => {
                console.log(`ICE Connection state change: ${this.peerConnection.iceConnectionState}`);
            });
            this.peerConnection.addEventListener('icegatheringstatechange', () => {
                console.log(`ICE gathering state changed: ${this.peerConnection.iceGatheringState}`);
            });
            this.peerConnection.addEventListener('datachannel', (ev) => {
                console.log(`New channel created: ${ev.channel}`);
                this.channel = ev.channel;
                this.channel.addEventListener('open', () => {
                    console.log(`Channel Status: ${this.channel.readyState}`);
                });
                this.channel.addEventListener('close', () => {
                    console.log(`Channel Status: ${this.channel.readyState}`);
                    alert('Your peer disconnected');
                    this.hangUp();
                });
                this.channel.addEventListener('message', (event) => {
                    const data = JSON.parse(event.data);
                    console.log(`Message Received: ${data}`);
                    if (data.selfiemode) {
                        if (!data.selfiemode.value) {
                            const photowrap = document.getElementById('photowrap');
                            photowrap.style.display = 'none';
                            this.picture = null;
                            this.selfieDone = null;
                        }
                        this.selfiemode = data.selfiemode.value;
                        this.resize();
                    }
                    if (data.picture) {
                        this.picture = data.picture.value;
                    }
                    if (data.meetingId) {
                        this.meetingId = data.meetingId.value;
                    }
                    if (data.timer) {
                        const timer = data.timer;
                        const status = timer.status;
                        const end = timer.end;
                        if (status === 'running') {
                            this.startTimer(end);
                        }
                    }
                });
            });
        },
        sendMessage(message) {
            console.log(`Sending message ${JSON.stringify(message)}`);
            this.channel.send(JSON.stringify(message));
        },
        startTimer(endTime) {
            this.timerActive = setInterval(() => {
                let end = new Date();
                let minutes;
                let seconds;
                end.setMilliseconds(0);
                if (!this.timer) {
                    const now = new Date();
                    end = new Date(endTime);
                    const distance = end - now;
                    minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
                    seconds = Math.floor((distance % (1000 * 60)) / 1000);
                } else {
                    end.setMinutes(this.timer.split(':')[0]);
                    end.setSeconds(this.timer.split(':')[1]);
                    end.setSeconds(end.getSeconds() - 1);
                    minutes = end.getMinutes();
                    seconds = end.getSeconds();
                }
                if (minutes < 1 && seconds < 1) {
                    this.hangUp();
                }
                this.timer = `${(minutes < 10 ? '0' : '') + minutes}:
                ${(seconds < 10 ? '0' : '') + seconds}`;
            }, 1000);
        },
        pauseTimer() {
            alert('Feature not yet implemented');
        },
        takeASelfie() {
            alert('Feature not yet implemented');
        },
        hangUp() {
            console.log('Ending call');
            this.started = false;
            this.mediaOpen = false;
            this.localStream.getTracks().forEach((track) => {
                track.stop();
            });
            this.peerConnection.close();
            window.addEventListener('resize', () => {});
            this.$router.push({ name: 'FANFinalPage', params: { meetingId: this.meetingId } });
        },
        resize() {
            // if (this.mediaOpen && this.started) {
            const topbar = document.getElementById('topbar').offsetHeight;
            const lowbar = document.getElementById('lowbar').offsetHeight;
            const contentHeight = window.innerHeight - topbar - lowbar;
            const contentWidth = window.innerWidth;
            document.getElementsByClassName('fullwin')[0].style.height = `${contentHeight}px`;
            if (this.selfiemode) {
                if (contentHeight < ((contentWidth / 2) * 9) / 8) {
                    this.vidHeight = (contentHeight / 1.5);
                    this.vidWidth = ((contentHeight / 1.5) * 9) / 8;
                } else {
                    this.vidHeight = ((contentWidth / 2.15) * 8) / 9;
                    this.vidWidth = (contentWidth / 2.15);
                }
            } else if (contentHeight > contentWidth) {
                const vids = document.getElementsByClassName('vidwrap');
                vids.forEach((v, i) => {
                    vids[i].classList.remove('col-6');
                    vids[i].classList.add('col-12');
                });
                this.vidHeight = (contentHeight / 2.15);
                this.vidWidth = ((contentHeight / 2.15) * 1280) / 720;
            } else {
                const vids = document.getElementsByClassName('vidwrap');
                vids.forEach((v, i) => {
                    vids[i].classList.remove('col-12');
                    vids[i].classList.add('col-6');
                });
                if (contentHeight < ((contentWidth / 2) * 400) / 300) {
                    this.vidHeight = (contentHeight);
                    this.vidWidth = ((contentHeight) * 1280) / 720;
                } else {
                    this.vidHeight = ((contentWidth / 2.15) * 400) / 300;
                    this.vidWidth = (contentWidth / 2.15);
                }
            }
            // }
        }
    },
    created() {
        if (!this.$store.state.currentKalameeting) {
            this.$router.push('/');
        } else {
            this.roomId = this.$store.state.currentKalameeting;
        }
    },
    mounted() {
        this.resize();
        window.addEventListener('resize', () => {
            this.resize();
        });
        document.addEventListener('beforeunload', this.hangUp());
        document.addEventListener('unload', this.hangUp());
    }
};

export default vm;
</script>
